import { useEffect, useState } from "react";
import IAPI from "../../../models/IAPI";
import { IIntegrationAccessCollection } from "../../../models/IIntegrationAccessCollection";
import IIntegrationRepository from "../../../services/IIntegrationRepository";
import Services from "../../../services/Services";

function useIntegration(token: string, companyId: number, integrationId: number) {
  const [apiToken, setAPIToken] = useState<string>(token);
  const [integrationCompanyId, setIntegrationCompanyId] = useState<number>(companyId);
  const [integrationID, setIntegrationID] = useState<number>(integrationId);
  const [showRemoveAPIsDialog, setShowRemoveAPIsDialog] = useState<boolean>(false);
  const [removeAPIsConfirmed, setRemoveAPIsConfirmed] = useState<boolean>(false);
  const [apis, setApis] = useState<IAPI[]>([]);
  const [access, setAccess] = useState<IIntegrationAccessCollection>();
  const [showXMLFieldsDialog, setShowXMLFieldsDialog] = useState<boolean>(false);
  const [showCustomAPIFieldsDialog, setShowCustomAPIFieldsDialog] = useState<boolean>(false);
  const [showSubmitForProductionDialog, setShowSubmitForProductionDialog] = useState<boolean>(false);
  const [showQmlativAccess, setShowQmlativAccess] = useState<boolean>(false);

  useEffect(() => {
    const getAPIs = async () => {
      let integrationRepo: IIntegrationRepository = await new Services().IntegrationRepository();
      if (integrationId > 0) {
        const data: IAPI[] = await integrationRepo.getAPIsByID(apiToken, integrationId);

        if (data) {
          setApis(data);
        }
      }
    };

    const getAccess = async () => {
      let integrationRepo: IIntegrationRepository = await new Services().IntegrationRepository();
      if (integrationId > 0) {
        const data: IIntegrationAccessCollection = await integrationRepo.getIntegrationFields(token, integrationId);

        if (data) {
          setAccess(data);
        }
      }
    };

    getAPIs();
    getAccess();
  }, [integrationId, showCustomAPIFieldsDialog]);

  return {
    apiToken,
    integrationCompanyId: integrationCompanyId,
    integrationID: integrationID,
    showRemoveAPIsDialog,
    setShowRemoveAPIsDialog,
    removeAPIsConfirmed,
    setRemoveAPIsConfirmed,
    apis,
    setApis,
    access,
    setAccess,
    showXMLFieldsDialog,
    setShowXMLFieldsDialog,
    showCustomAPIFieldsDialog,
    setShowCustomAPIFieldsDialog,
    showSubmitForProductionDialog,
    setShowSubmitForProductionDialog,
    showQmlativAccess,
    setShowQmlativAccess,
  };
}

export { useIntegration };
